import type { FluxErrorEntityErrorCodes } from '../types.js';

export const UploadErrorCodes = {
  UploadOnlyImage: {
    code: 'upload/only-image',
    explanation:
      'Apenas arquivos de imagem são permitidos para este upload, imagens aceitas incluem: JPG, JPEG, PNG.',
    localizations: {},
    message: 'Apenas arquivos de imagem são permitidos neste campo.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'upload'>;
